import _toConsumableArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "core-js/modules/esnext.global-this.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

import { CustomVideoElement } from 'custom-media-element';
import { MediaTracksMixin } from 'media-tracks';
import Hls from 'hls.js/dist/hls.mjs';

var HlsVideoMixin = function HlsVideoMixin(superclass) {
  var _destroy;

  return _destroy = /*#__PURE__*/new WeakSet(), /*#__PURE__*/function (_superclass) {
    _inherits(HlsVideo, _superclass);

    var _super = _createSuper(HlsVideo);

    function HlsVideo() {
      var _this;

      _classCallCheck(this, HlsVideo);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _classPrivateMethodInitSpec(_assertThisInitialized(_this), _destroy);

      return _this;
    }

    _createClass(HlsVideo, [{
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attrName, oldValue, newValue) {
        if (attrName !== 'src') {
          _get(_getPrototypeOf(HlsVideo.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);
        }

        if (attrName === 'src' && oldValue != newValue) {
          this.load();
        }
      }
    }, {
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this2 = this;

          var _this$videoRenditions, loadSourceOnPlay, originalLength, originalSize, increaseBufferOnPlay, levelIdMap, switchRendition, smoothSwitch, removeAllMediaTracks;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _classPrivateMethodGet(this, _destroy, _destroy2).call(this);

                  if (this.src) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return");

                case 3:
                  if (!Hls.isSupported()) {
                    _context.next = 35;
                    break;
                  }

                  this.api = new Hls({
                    // Mimic the media element with an Infinity duration for live streams.
                    liveDurationInfinity: true
                  }); // Wait 1 tick to allow other attributes to be set.

                  _context.next = 7;
                  return Promise.resolve();

                case 7:
                  _context.t0 = this.nativeEl.preload;
                  _context.next = _context.t0 === 'none' ? 10 : _context.t0 === 'metadata' ? 14 : 23;
                  break;

                case 10:
                  // when preload is none, load the source on first play
                  loadSourceOnPlay = function loadSourceOnPlay() {
                    return _this2.api.loadSource(_this2.src);
                  };

                  this.nativeEl.addEventListener('play', loadSourceOnPlay, {
                    once: true
                  });
                  this.api.on(Hls.Events.DESTROYING, function () {
                    _this2.nativeEl.removeEventListener('play', loadSourceOnPlay);
                  });
                  return _context.abrupt("break", 24);

                case 14:
                  originalLength = this.api.config.maxBufferLength;
                  originalSize = this.api.config.maxBufferSize; // load the least amount of data possible

                  this.api.config.maxBufferLength = 1;
                  this.api.config.maxBufferSize = 1; // and once a user has player, allow for it to load data as normal

                  increaseBufferOnPlay = function increaseBufferOnPlay() {
                    _this2.api.config.maxBufferLength = originalLength;
                    _this2.api.config.maxBufferSize = originalSize;
                  };

                  this.nativeEl.addEventListener('play', increaseBufferOnPlay, {
                    once: true
                  });
                  this.api.on(Hls.Events.DESTROYING, function () {
                    _this2.nativeEl.removeEventListener('play', increaseBufferOnPlay);
                  });
                  this.api.loadSource(this.src);
                  return _context.abrupt("break", 24);

                case 23:
                  // load source immediately for any other preload value
                  this.api.loadSource(this.src);

                case 24:
                  this.api.attachMedia(this.nativeEl); // Set up tracks & renditions
                  // Create a map to save the unique id's we create for each level and rendition.
                  // hls.js uses the levels array index primarily but we'll use the id to have a
                  // 1 to 1 relation from rendition to level.

                  levelIdMap = new WeakMap();
                  this.api.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                    removeAllMediaTracks();

                    var videoTrack = _this2.videoTracks.getTrackById('main');

                    if (!videoTrack) {
                      videoTrack = _this2.addVideoTrack('main');
                      videoTrack.id = 'main';
                      videoTrack.selected = true;
                    }

                    var _iterator = _createForOfIteratorHelper(data.levels.entries()),
                        _step;

                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            id = _step$value[0],
                            level = _step$value[1];

                        var videoRendition = videoTrack.addRendition(level.url[0], level.width, level.height, level.videoCodec, level.bitrate); // The returned levels all have an id of `0`, save the id in a WeakMap.

                        levelIdMap.set(level, "".concat(id));
                        videoRendition.id = "".concat(id);
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }

                    var _iterator2 = _createForOfIteratorHelper(data.audioTracks.entries()),
                        _step2;

                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var _step2$value = _slicedToArray(_step2.value, 2),
                            _id = _step2$value[0],
                            a = _step2$value[1];

                        // hls.js doesn't return a `kind` property for audio tracks yet.
                        var kind = a.default ? 'main' : 'alternative';

                        var audioTrack = _this2.addAudioTrack(kind, a.name, a.lang);

                        audioTrack.id = "".concat(_id);

                        if (a.default) {
                          audioTrack.enabled = true;
                        }
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  });
                  this.audioTracks.addEventListener('change', function () {
                    var _find;

                    // Cast to number, hls.js uses numeric id's.
                    var audioTrackId = +((_find = _toConsumableArray(_this2.audioTracks).find(function (t) {
                      return t.enabled;
                    })) === null || _find === void 0 ? void 0 : _find.id);

                    var availableIds = _this2.api.audioTracks.map(function (t) {
                      return t.id;
                    });

                    if (audioTrackId != _this2.api.audioTrack && availableIds.includes(audioTrackId)) {
                      _this2.api.audioTrack = audioTrackId;
                    }
                  }); // Fired when a level is removed after calling `removeLevel()`

                  this.api.on(Hls.Events.LEVELS_UPDATED, function (event, data) {
                    var _this2$videoTracks$se;

                    var videoTrack = _this2.videoTracks[(_this2$videoTracks$se = _this2.videoTracks.selectedIndex) !== null && _this2$videoTracks$se !== void 0 ? _this2$videoTracks$se : 0];
                    if (!videoTrack) return;
                    var levelIds = data.levels.map(function (l) {
                      return levelIdMap.get(l);
                    });

                    var _iterator3 = _createForOfIteratorHelper(_this2.videoRenditions),
                        _step3;

                    try {
                      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                        var rendition = _step3.value;

                        if (rendition.id && !levelIds.includes(rendition.id)) {
                          videoTrack.removeRendition(rendition);
                        }
                      }
                    } catch (err) {
                      _iterator3.e(err);
                    } finally {
                      _iterator3.f();
                    }
                  }); // hls.js doesn't support enabling multiple renditions.
                  //
                  // 1. if all renditions are enabled it's auto selection.
                  // 2. if 1 of the renditions is disabled we assume a selection was made
                  //    and lock it to the first rendition that is enabled.

                  switchRendition = function switchRendition(event) {
                    var level = event.target.selectedIndex;

                    if (level != _this2.api.nextLevel) {
                      smoothSwitch(level);
                    }
                  }; // Workaround for issue changing renditions on an alternative audio track.
                  // https://github.com/video-dev/hls.js/issues/5749#issuecomment-1684629437


                  smoothSwitch = function smoothSwitch(levelIndex) {
                    var currentTime = _this2.currentTime;
                    var flushedFwdBuffer = false;

                    var callback = function callback(event, data) {
                      flushedFwdBuffer || (flushedFwdBuffer = !Number.isFinite(data.endOffset));
                    };

                    _this2.api.on(Hls.Events.BUFFER_FLUSHING, callback);

                    _this2.api.nextLevel = levelIndex;

                    _this2.api.off(Hls.Events.BUFFER_FLUSHING, callback);

                    if (!flushedFwdBuffer) {
                      _this2.api.trigger(Hls.Events.BUFFER_FLUSHING, {
                        startOffset: currentTime + 10,
                        endOffset: Infinity,
                        type: 'video'
                      });
                    }
                  };

                  (_this$videoRenditions = this.videoRenditions) === null || _this$videoRenditions === void 0 ? void 0 : _this$videoRenditions.addEventListener('change', switchRendition);

                  removeAllMediaTracks = function removeAllMediaTracks() {
                    var _iterator4 = _createForOfIteratorHelper(_this2.videoTracks),
                        _step4;

                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        var videoTrack = _step4.value;

                        _this2.removeVideoTrack(videoTrack);
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }

                    var _iterator5 = _createForOfIteratorHelper(_this2.audioTracks),
                        _step5;

                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        var audioTrack = _step5.value;

                        _this2.removeAudioTrack(audioTrack);
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                  };

                  this.api.once(Hls.Events.DESTROYING, removeAllMediaTracks);
                  return _context.abrupt("return");

                case 35:
                  _context.next = 37;
                  return Promise.resolve();

                case 37:
                  // Use native HLS. e.g. iOS Safari.
                  if (this.nativeEl.canPlayType('application/vnd.apple.mpegurl')) {
                    this.nativeEl.src = this.src;
                  }

                case 38:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function load() {
          return _load.apply(this, arguments);
        }

        return load;
      }()
    }]);

    return HlsVideo;
  }(superclass);

  function _destroy2() {
    if (this.api) {
      this.api.detachMedia();
      this.api.destroy();
      this.api = null;
    }
  }
};

var HlsVideoElement = HlsVideoMixin(MediaTracksMixin(CustomVideoElement));

if (globalThis.customElements && !globalThis.customElements.get('hls-video')) {
  globalThis.customElements.define('hls-video', HlsVideoElement);
}

export default HlsVideoElement;
export { Hls, HlsVideoMixin, HlsVideoElement };